module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Avg Item Price"}}')
  delete Component.options._Ctor
}
